import { primitives } from './generated/tokens.generated';
import PAIRINGS from './lineHeightPairings.json';

export const toRem: (n: number) => string = (n: number) => `${n / 16}rem`;

// (lineHeightPx / fontSizePx) * 100, rounded to a whole percent. A non-positive size
// falls back to '100%' rather than divide by zero.
const percentOf: (fontSizePx: number, lineHeightPx: number) => string = (fontSizePx, lineHeightPx) => (fontSizePx > 0 ? `${Math.round((lineHeightPx / fontSizePx) * 100)}%` : '100%');

const { fontSize: size, lineHeight: leading } = primitives;

// Figma's type roles never pair one font size with two line-heights, so a size alone
// resolves its pairing.
const LINE_HEIGHT_BY_FONT_SIZE: Record<number, number> = Object.fromEntries(
  Object.entries(PAIRINGS as Record<keyof typeof size, keyof typeof leading>).map(([fontSize, lineHeight]) => [size[fontSize as keyof typeof size], leading[lineHeight]])
);

/**
 * The line-height paired with a font size on the type scale, as a CSS percentage of that size.
 * e.g. lineHeight(theme.font.size.md) => '143%' (14px / 20px)
 *
 * An off-scale or non-positive size has no pairing and falls back to '100%'.
 */
export const lineHeight: (fontSizePx: number) => string = (fontSizePx) => percentOf(fontSizePx, LINE_HEIGHT_BY_FONT_SIZE[fontSizePx] ?? fontSizePx);
